/** The colour a tile is painted in: its kind's colour, darker in a group, lighter when raised, a touch different per tile. */
import { KIND } from '@bramvasterd/terrella-rules';
import * as THREE from 'three';

import { hash2 } from '@core/math';
import { GROUP_TOP, HIGH_STONE, TILE_TOP } from '@core/palette';

import type { PlanetView } from './view';

const _highStone = new THREE.Color(HIGH_STONE);
/** Rock a charge broke is darker: the shade of its broken face. */
const BROKEN_SHADE = 0.78;

export function tileBase(view: PlanetView, i: number, out: THREE.Color): THREE.Color {
  const kind = view.kind[i] ?? 0;
  const grouped = view.groups[i] === 1 && GROUP_TOP[kind] !== undefined;
  out.set((grouped ? GROUP_TOP[kind] : TILE_TOP[kind]) ?? 0xffffff);
  if (kind === KIND.STONE && (view.elev[i] ?? 0) > 0) out.lerp(_highStone, 0.55);
  out.offsetHSL(0, 0, (hash2(i, kind + 11) - 0.5) * 0.04);
  if (view.shattered?.[i]) out.multiplyScalar(BROKEN_SHADE);
  return out;
}
